import React, { useEffect, useState } from 'react';
import { getBackendVersion } from '../api/Version';
import { injectIntl } from 'react-intl';

/**
 * Gets the app name and version from package.json via .env file
 * Gets the backend version from the API
 */
 export const Version = () => {
  const [version, setVersion] = useState("");

  useEffect(() => {

    async function fetchVersion() {
      let version = await getBackendVersion()
      console.log("useEffect(), version here", version);
      setVersion(version ? version : "");
    }

    fetchVersion()
  }, []);

  return <div className="Version">{process.env.REACT_APP_NAME} v{process.env.REACT_APP_VERSION} sernet v{version}</div>
}

export default injectIntl(Version);
